import tagTester from './_tagTester.js';

export default tagTester('Date');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isDate.js
// module id = 153
// module chunks = 3